'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Button = require('../../Button');

var _Button2 = _interopRequireDefault(_Button);

var _Close = require('../../Icons/dist/components/Close');

var _Close2 = _interopRequireDefault(_Close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseButton = function CloseButton() {
  return _react2.default.createElement(
    _Button2.default,
    { height: 'medium', theme: 'close-transparent', onClick: function onClick(e) {
        return e.preventDefault();
      } },
    _react2.default.createElement(_Close2.default, { size: '6px' })
  );
};

CloseButton.displayName = 'Notification.CloseButton';

exports.default = CloseButton;